import React, { useState, useEffect } from 'react';
import { FaSearch, FaFileExcel } from 'react-icons/fa';
import axios from '../../../axiosInstance';
import * as XLSX from 'xlsx';
import './ViewsList.css';
import Sidebar_admin from '../Sidebar_Admin/Sidebar_admin';

const ViewsList = () => {
  const [viewsList, setViewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredViews, setFilteredViews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    const fetchViewsData = async () => {
      try {
        const response = await axios.get('/api/news/views');
        setViewsList(response.data);
        setFilteredViews(response.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError('Failed to load views data');
        setLoading(false);
      }
    };

    fetchViewsData();
  }, []);

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filtered = viewsList.filter((view) =>
      view.newsId.toString().includes(query) || view.reporterId.toString().includes(query)
    );
    setFilteredViews(filtered);
    setCurrentPage(1);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredViews);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Views Data');
    XLSX.writeFile(wb, 'views_data.xlsx');
  };

  const totalPages = Math.ceil(filteredViews.length / itemsPerPage);
  const currentData = filteredViews.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div>
      <Sidebar_admin />
      <div className="views-list-container">
        <h4 className="views-list-title">Views List</h4>
        <div className="search-bar">
          <input
            type="text"
            className="search-input"
            placeholder="Search by News ID or Reporter ID..."
            value={searchQuery}
            onChange={handleSearch}
          />
          <FaSearch className="search-icon" />
        </div>
        <div className="export-btn-container">
          <button className="export-btn" onClick={exportToExcel}>
            <FaFileExcel className="export-icon" /> Export to Excel
          </button>
        </div>
        {loading ? (
          <p className="loading-message">Loading views...</p>
        ) : error ? (
          <p className="error-message">{error}</p>
        ) : (
          <div className="table-container">
            <table className="views-table">
              <thead>
                <tr>
                  <th>News ID</th>
                  <th>Reporter ID</th>
                  <th>Today Views</th>
                  <th>Total Views</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((view, index) => (
                  <tr key={index}>
                    <td>{view.newsId}</td>
                    <td>{view.reporterId}</td>
                    <td>{view.todayViews || 0}</td>
                    <td>{view.totalViews || view.viewCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                Previous
              </button>
              <span> Page {currentPage} of {totalPages} </span>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewsList;
